<doc>
  @desc:   布局 - 热门新闻组件
  @author:  
</doc>
<template>
  <div class="hot-news-wrapper" v-if="newsListLast.length>0">
    <div class="news-title flex flex-align-center">
      <i class="news-title-icon icon-font icon-news"></i>
      <h3 class="news-title-text">{{ langConfig.txtLang[langConfig.curLang]['NEWS'] }}</h3>
    </div>
    <div class="news-item">
      <ul class="news-list">
        <li v-for="(item,index) in newsListLast" :key="index">
          <span><router-link :to="toNewsInfo(item)">{{ item.title }}</router-link></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      newsListLast: {
        type: Array,
        default: () => [],
      }
    },

    data(){
      return{
      }
    },

    mounted(){
    },

    methods: {
      // 详情
      toNewsInfo(item){
        let title = this.common.formalTitle(item.title)
        
        return `/newsInfo/${item.id}/${title}`
        //this.$router.push(`/newsInfo/${item.id}/${title}`);
      },
    }
  }
</script>

<style lang="less">
.hot-news-wrapper{
  padding:20px 0;
  margin:0 16px;
  border-bottom:1px solid @color_D9D9D9;
  .news-title-icon{
    color:@color_8C8C8C;
    font-size:22px;
    margin-right:6px;
  }
  .news-title-text{
    color:#000;
    font-size:16px;
    font-weight:600;
    font-family: @font_family_SF_Pro_Display;
  }
  .news-list{
    li{
      margin-top:16px;
      span{
        color:@color_434343;
        font-size:14px;
        font-family: @font_family_SF_Pro_Display;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-clamp: 1;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        a{
          color:@color_434343;
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/hotNews.vue